// 物料信息-编辑
import { useEffect, useReducer } from 'react'
import { Button, message, Form, Skeleton, Space, Divider } from 'antd'
import Maininfo from '../../modules/goodsdetailmodules/maininfo'
import Uploadimg from '../../modules/goodsdetailmodules/uploadimg'
import AptitudeAttach from '../../modules/goodsdetailmodules/AptitudeAttach'
import Style from './goodsmanage.module.scss'
import { ADD_PRODUCTCHILD, GET_CODEPRODUCT_DETAIL } from '../../api/MaterialApi'
import { GET_CATEGORY_FRONTEND_HINT_TEXT } from '@/api/categoryQualificationApi'
import { history, useTypedSelector } from '../../redux/store'
import { useDispatch } from 'react-redux'
import { ProductChildParams } from '../../api/Params'
import {
  setformStateInitAction,
  setformStateAction,
} from '../../modules/ControlformState'
import { useLocation } from 'react-router-dom'
import { setModuleDataAction } from '../../modules/pagecache'
import CustomModal from '../../components/ModalUser'
import Record from './components/record'
import useHook from './hook'
import Originalpic from '../../modules/goodsdetailmodules/originalpic'
import { RoleType, isResponseCodeSuccess } from '../../tools/util'
import Mainpic from '../../modules/goodsdetailmodules/mainpic'
import Secondaryinfo from '../../modules/goodsdetailmodules/secondaryinfo'
import Expandattr from '../../modules/goodsdetailmodules/expandattr'
import MaterialType from '../../modules/goodsdetailmodules/materialType'
import AssociationItems from '../../modules/goodsdetailmodules/associationItems'
import { materialTypeEnum } from '../../global/enum/product'
import ExternalLink, {
  ExternalLinkType,
  toExternalLinkPayload,
} from '@/modules/goodsdetailmodules/externallink'

const ACTION_TYPE = {
  SET_CURRENT_PARAM: 'set_current_param', // 设置当前页面参数
  CHANGE_DATA: 'CHANGE_DATA', // 替换所有状态
  CHANGE_ISASSESSINGDATA: 'CHANGE_ISASSESSINGDATA',
  CHANGE_LOADING: 'CHANGE_LOADING',
  SET_DISPLAY_DEL_BTN_INDEX: 'SET_DISPLAY_DEL_BTN_INDEX', // 关联项目信息列表隐藏删除按钮
  CHANGE_CAN_ITEM_EDIT: 'CHANGE_CAN_ITEM_EDIT', // 关联项目信息是否可编辑
}
interface State {
  // 当前参数
  currentparam: nowpagesparam
  isAssessing: string
  isloading: boolean
  displayDelBtnIndex: number
  canItemEdit: boolean
}
interface nowpagesparam {
  tempId?: string // 暂存商品 id
  childId?: string // 子商品 id
  // 选中的tree层级
  selectTreeData?: treeType
  BtnState?: MaterialDetailType[] // 模块状态
}
export interface treeType {
  id: string // 树 id
  title: string // 树名称
  level: string // 树层级
  parentId?: string // 父级id
}
const defaultState: State = {
  currentparam: {},
  isAssessing: '0',
  isloading: false,
  displayDelBtnIndex: 0,
  canItemEdit: false,
}
const reducer = (state: State, action: { type: string; value?: any }) => {
  let arr = { ...state }
  switch (action.type) {
    case ACTION_TYPE.SET_CURRENT_PARAM:
      arr.currentparam = action.value
      return arr
    case ACTION_TYPE.CHANGE_DATA:
      arr = action.value
      return arr
    case ACTION_TYPE.CHANGE_ISASSESSINGDATA:
      arr.isAssessing = action.value
      return arr
    case ACTION_TYPE.CHANGE_LOADING:
      arr.isloading = action.value
      return arr
    case ACTION_TYPE.SET_DISPLAY_DEL_BTN_INDEX:
      arr.displayDelBtnIndex = action.value
      return arr
    case ACTION_TYPE.CHANGE_CAN_ITEM_EDIT:
      arr.canItemEdit = action.value
      return arr
    default:
      return { ...state }
  }
}

const setChangeLoading = (params: boolean) => ({
  type: ACTION_TYPE.CHANGE_LOADING,
  value: params,
})
const setAssessing = (params: string) => ({
  type: ACTION_TYPE.CHANGE_ISASSESSINGDATA,
  value: params,
})
// 重新加载数据
const reloadDataAction = (params: State) => ({
  type: ACTION_TYPE.CHANGE_DATA,
  value: params,
})

// 设置关联项目信息列表隐藏删除按钮
const setDisplayDelbtnIndex = (params: number) => ({
  type: ACTION_TYPE.SET_DISPLAY_DEL_BTN_INDEX,
  value: params,
})

// 关联项目信息是否可编辑
const changeCanItemEditAction = (params: boolean) => ({
  type: ACTION_TYPE.CHANGE_CAN_ITEM_EDIT,
  value: params,
})

// 路由参数
interface RouteParam extends nowpagesparam {
  init?: boolean // 是否初始化
  copydata?: any // copy
}

const Goodsdetail = () => {
  const {
    usehookstate,
    form,
    platform_form,
    setProjectQuotation,
    onChangePic,
    onChangeAptitude,
    onChangeDetailPic,
    onChangeCate,
    onChangeBrandSale,
    onClickClose,
    onCancelrecord,
    onChangeLoading,
    getformatFormFields,
    reloaddata,
    tempCode,
    setTempCodeFun,
    onChangeDelivery,
    setMaterialType,
    formatFormFields,
    changeItemList,
    onFieldsChange,
    clickCopy,
    externalLinkList,
    setExternalLinkList,
    setQualityDataList,
    checkProductForbidChar,
    checkTaxCodeBlacklist,
    setReportFieldConfigList,
    savedReportFieldValues,
    setDetailAuditType,
  } = useHook()
  const [pagesstate, dispatch] = useReducer(reducer, defaultState)
  const dispatchRedux = useDispatch()
  const {
    projectQuotation,
    pictures,
    qualDocFileList,
    requiredAttachTypes,
    frontendHintText,
    detailPic,
    productCode,
    fieldList,
    isRecord,
    loadingPage,
    hasDelivery,
    unitDisabled,
    materialType,
    itemsList,
    qualityDataList,
  } = usehookstate
  const { isAssessing, isloading, canItemEdit } = pagesstate
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { tempId, childId } = pagesstate.currentparam
  const { role } = useTypedSelector((state) => state.authtoken)
  const { pagekey } = useTypedSelector((state) => state.pageCache)
  const location = useLocation<RouteParam>()
  const { state, pathname } = location
  // 控制异步请求标识
  useEffect(() => {
    const flag = getpagecache()
    if (flag && !state) {
      // 读取缓存的公共模块状态
      reloaddata(flag.commonState)
      // 设置form数据
      form.setFieldsValue(flag.formState)
      // 读取缓存的当前模块状态
      dispatch(reloadDataAction(flag.pageState))
      dispatch(setAssessing(flag.formState.isAssessing))
      // 判断物料属性
      materialattrDisabled(flag.pageState.currentparam.BtnState)
    } else if (state) {
      dispatchRedux(setformStateInitAction())
      materialattrDisabled(state.BtnState)
      getProductInfo(state)
      // form.setFieldsValue({ childId: state.childId });//设置物料id 如果为新增则是空 用于maininfo页面判断
    }
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    // 缓存存数据
    const pathName = history.location.pathname + 'goodsInfo'
    const formstate = form.getFieldsValue()
    const action = setModuleDataAction({
      key: pathName,
      data: {
        commonState: usehookstate, // 公共状态
        pageState: pagesstate, // 当前状态
        formState: formstate,
      },
    })
    dispatchRedux(action)
    return () => {
      const formstate = form.getFieldsValue()
      const action = setModuleDataAction({
        key: pathName,
        data: {
          commonState: usehookstate, // 公共状态
          pageState: pagesstate, // 当前状态
          formState: formstate,
        },
      })
      dispatchRedux(action)
    }
    // eslint-disable-next-line
  }, [usehookstate, pagesstate])

  const handleLinkChange = (newList: ExternalLinkType[]) => {
    setExternalLinkList(newList)
  }

  // 获取数据
  const getpagecache = () => {
    const pathName = history.location.pathname + 'goodsInfo'
    const data = pagekey.filter((item) => item.key === pathName)
    if (data.length === 1) {
      return data[0].data
    }
    return null
  }

  // 编辑获取数据
  const getProductInfo = async (state: any) => {
    onChangeLoading(true)
    const res = await GET_CODEPRODUCT_DETAIL({
      code: state.tempCode,
    })
    if (isResponseCodeSuccess(res.code)) {
      const resData = res.data
      // 资质场景：依据详情返参 auditType（ADD/MODIFY）推算
      setDetailAuditType(resData.auditType)
      // 初始进入详情：通过类目 ID 调接口获取当前四级类目的前台提示文案
      const hintRes = await GET_CATEGORY_FRONTEND_HINT_TEXT({
        categoryId: resData.cateMdmId,
      })
      const frontendHintText = isResponseCodeSuccess(hintRes.code)
        ? hintRes.data
        : ''
      await onChangeCate(
        resData.cateMdmId,
        undefined,
        resData.code,
        frontendHintText,
      )
      dispatch(setAssessing(resData.isAssessing))
      // 编辑我的物料时，若物料的关联项目为空，此时可以对项目信息进行修改和新增
      resData.projectValueInfoList.length === 0 &&
        dispatch(changeCanItemEditAction(true))
      const formatData = formatFormFields(resData)
      dispatch(setDisplayDelbtnIndex(resData.projectValueInfoList.length))
      form.setFieldsValue(formatData)
      setTempCodeFun(resData.code)
      setProjectQuotation(resData.projectQuotation)
      const newExternalLinks = resData.externalLinks.map((item: any) => {
        return {
          ...item,
          externalFile: item.externalFile ? JSON.parse(item.externalFile) : [],
        }
      })
      setExternalLinkList(newExternalLinks)
    }
    onChangeLoading(false)
  }

  // 物料属性是否可修改
  const materialattrDisabled = (params?: MaterialDetailType[]) => {
    let flag = false
    if (role === RoleType.SOURCE_PURCHASE_MAN && params) {
      // 采购员 物料属性
      flag = params.indexOf('Add') !== -1 ? false : true
    }
    dispatchRedux(setformStateAction([{ key: 'materialattr', disabled: flag }]))
  }

  // 提交新增物料 暂存物料提交 数据
  async function onSubmmit() {
    try {
      // 格式化表单数据
      const values = await getformatFormFields()
      const canPassForbidCharCheck = await checkProductForbidChar(values)
      if (!canPassForbidCharCheck) {
        return
      }
      // 提交前校验税编是否命中当前货主的黑名单。货主由 MPM 按物料类型推导，
      // 这里只把 productType 传过去，不在前端算货主，避免两端口径走偏
      const canPassBlacklistCheck = await checkTaxCodeBlacklist(
        values.productType,
        values.taxCategoryCode,
      )
      if (!canPassBlacklistCheck) {
        return
      }
      if (qualityDataList.length > 10) {
        message.warning('资质图片最多上传10张')
        return
      }
      if (
        !itemsList.length &&
        materialTypeEnum.getLabelByValue(values.productType) ===
          '电商供应商物料'
      ) {
        message.error('电商供应商物料至少添加一个关联项目')
        return
      }
      const params: any = {
        ...values,
        saveType: '2', // 必须 操作类型；1、提交 2、暂存
        fourthCateMdmId: values.fourthCateMdmId || values.cateMdmId, // 类目ID
        externalLinks: toExternalLinkPayload(externalLinkList),
      }
      // editgoods 路由下不传 reportFieldValues
      if (pathname.includes('editgoods')) {
        delete params.reportFieldValues
      }
      if ((!childId && !tempId) || (tempId && !childId)) {
        // 校验品牌型号问题
        commit(params)
      } else {
        // 直接提交
        commit(params)
      }
    } catch (errorInfo) {
      const error = (errorInfo as any).errorFields[0].errors[0]
      message.warning(error)
      const errorname = (errorInfo as any).errorFields[0].name
      // 返回报错信息，滚动到第一个报错的位置
      form.scrollToField(errorname.toString(), { behavior: 'smooth' })
    }
  }

  // 提交数据 立即提交 暂存
  async function commit(params: ProductChildParams) {
    dispatch(setChangeLoading(true))
    const msg = '提交中'
    message.loading(msg, 0)
    const resData = await ADD_PRODUCTCHILD(params)
    dispatch(setChangeLoading(false))
    if (resData.code === 0) {
      if (childId) {
        message.success('已提交')
      } else {
        message.success('已成功')
      }
      onClickClose(history.location.pathname + 'goodsInfo')
    } else {
      message.destroy()
    }
  }

  // 按钮类型
  const ButtonComponents = () => {
    let EditBtn = null
    const EditChild = null
    const DisableBtn = null
    const UndisableBtn = null
    const CopyBtn = null
    EditBtn =
      isAssessing !== '0' ? null : (
        <Button
          type="link"
          size="small"
          loading={isloading}
          onClick={() => onSubmmit()}
        >
          提交
        </Button>
      )
    return (
      <div className={Style.btnbox}>
        <div className={Style['btn-left-box']}></div>
        <div className={Style['btn-center-box']}></div>
        <div className={Style['btn-right-box']}>
          <Space>
            <Button type="link" size="small" onClick={clickCopy}>
              复制
            </Button>
            {EditBtn}
            {EditChild}
            {DisableBtn}
            {UndisableBtn}
            {CopyBtn}
            <Button type="link" size="small" onClick={onClickClose}>
              关闭
            </Button>
          </Space>
        </div>
      </div>
    )
  }

  const diaableMaterialType = () => {
    // 物料编辑页面禁止修改物料类型
    if (pathname.includes('editgoods')) {
      return true
    }

    return false
  }

  return (
    <Form.Provider>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <span style={{ paddingLeft: '20px' }}>
          项目报价员：{projectQuotation || '—'}
        </span>
        <ButtonComponents />
      </div>
      <div className={Style.container}>
        <div className={Style.box}>
          <Skeleton loading={loadingPage} active>
            <MaterialType
              form={form}
              setMaterialType={setMaterialType}
              type="single"
              diaableMaterialType={diaableMaterialType()}
              onFieldsChange={onFieldsChange}
            />
          </Skeleton>
        </div>
        <div className={Style.box}>
          <div className={Style.boxtitle}>
            <span>主要信息</span>
          </div>
          <Divider style={{ margin: '0' }} />
          <Skeleton loading={loadingPage} active>
            <Maininfo
              form={form}
              categoryReadOnly={pathname.includes('editgoods')}
              onChangeCate={onChangeCate}
              onChangeSale={onChangeBrandSale}
              tempCode={tempCode}
              unitDisabled={unitDisabled}
              materialType={materialType}
              onFieldsChange={onFieldsChange}
            />
          </Skeleton>
        </div>
        <div className={Style.box}>
          <div className={Style.boxtitle}>
            <span>次要信息</span>
          </div>
          <Divider style={{ margin: '0' }} />
          <Skeleton loading={loadingPage} active>
            <Secondaryinfo
              form={form}
              onChangeDelivery={onChangeDelivery}
              hasDelivery={hasDelivery}
              onFieldsChange={onFieldsChange}
            />
          </Skeleton>
        </div>
        {(materialType === '1' || materialType === '2') && (
          <div className={Style.box}>
            <div className={Style.boxtitle}>
              <span>关联项目信息</span>
              {materialTypeEnum.getLabelByValue(
                form.getFieldValue('productType'),
              ) === '电商供应商物料' && (
                <span style={{ color: '#ff4d4f', marginLeft: 10 }}>
                  * 请至少添加一个关联项目
                </span>
              )}
            </div>
            <Divider style={{ margin: '0' }} />
            <Skeleton loading={loadingPage} active>
              <AssociationItems
                form={platform_form}
                normalForm={form}
                onFieldsChange={onFieldsChange}
                itemsList={itemsList}
                changeItemList={changeItemList}
                readOnly={!canItemEdit}
                // 5.9.2需求由于mpm未处理完 暂时隐藏不跟随5.9.2版本上线
                // isEditView
                // displayDelBtnIndex={displayDelBtnIndex}
                qualityDataList={qualityDataList}
                setQualityDataListAction={setQualityDataList}
                isDetailPage={true}
              />
            </Skeleton>
          </div>
        )}

        <div className={Style.box}>
          <div className={Style.boxtitle}>
            <span>拓展属性</span>
            <span className={Style.tips}>
              拓展属性标题为<span className={Style.blueTip}>蓝色</span>
              代表有平台项目对该拓展属性有要求，鼠标移到拓展属性标题即可查看具体平台项目。
              <span
                style={{
                  color: '#8C8C8C',
                  fontSize: '12px',
                  lineHeight: '24px',
                }}
              >
                都需填写，无法填写的填/【如果是大批量无法填写，可能是四级类目选错】
              </span>
            </span>
          </div>
          <Divider style={{ margin: '0' }} />
          <Skeleton loading={loadingPage} active>
            <Expandattr
              form={form}
              fieldList={fieldList}
              itemsList={itemsList}
              frontendHintText={frontendHintText}
              onFieldsChange={onFieldsChange}
            />
          </Skeleton>
        </div>
        <div className={Style.box}>
          <Divider style={{ margin: '0' }} />
          <AptitudeAttach
            dataSource={qualDocFileList}
            onChange={onChangeAptitude}
            productCode={productCode}
            loading={loadingPage}
            requiredAttachTypes={requiredAttachTypes}
          />
        </div>
        <div className={Style.box}>
          <div className={Style.boxtitle}>
            <span>外部链接/价格佐证</span>
          </div>
          <Divider style={{ margin: '0' }} />
          <Skeleton loading={loadingPage} active>
            <ExternalLink
              form={form}
              externalLinkList={externalLinkList}
              onLinkChange={handleLinkChange}
            />
          </Skeleton>
        </div>
        <div className={Style.box}>
          <div className={Style.boxtitle}>
            <span>图文信息</span>
          </div>
          <Divider style={{ margin: '0' }} />
          <Skeleton loading={loadingPage} active>
            <div className={Style.picinfobox}>
              {/* <div className={Style.picinfotitle}>
                <span className={Style.text}>图片关系</span>
              </div> */}
              {/* true 显示 匹配、类似 注意必填校验 */}
              <Mainpic required form={form} onFieldsChange={onFieldsChange} />
              <div className={Style.picinfotitle}>
                <span className={Style.text}>
                  主图：
                  <span
                    style={{
                      color: '#8C8C8C',
                      fontSize: '12px',
                      lineHeight: '24px',
                    }}
                  >
                    尺寸：800×800 px。建议上传3张及以上，最多20张。第一张白底，其它尽量白底。主图要求颜色唯一，需要与描述或者拓展属性值一致【最低标准∶不低于在其他平台上架的标准】
                  </span>
                </span>
              </div>
              <Uploadimg
                dataSource={pictures}
                onChange={onChangePic}
                tempCode={tempCode}
                maxCount={20}
                fileType={'.bmp,.gif,.jpg,.png,.webp,.heic'}
                dragable
                aiEdit
              />
              {/* true 显示 可用、不可用 注意必填校验 */}
              <div hidden>
                <Originalpic
                  required={false}
                  form={form}
                  onFieldsChange={onFieldsChange}
                />
              </div>
              <div className={Style.picinfotitle}>
                <span className={Style.text}>
                  详情图：
                  <span
                    style={{
                      color: '#8C8C8C',
                      fontSize: '12px',
                      lineHeight: '24px',
                    }}
                  >
                    上传图片宽度不小于500 px，高度不限，最多100张。要图文丰富，需包含产品图、细节图、参数图、使用场景图，【最低标准:不低于在其他平台上架的标准】。一定不能包含:7天无理由退换货、送货上门、免费开票、水印、其它店铺信息、质保、包邮、链接、二维码、电话号码......等敏感词汇
                  </span>
                </span>
              </div>
              <Uploadimg
                dataSource={detailPic}
                onChange={onChangeDetailPic}
                tempCode={tempCode}
                isDetailPic
                fileType={'.bmp,.gif,.jpg,.png,.webp,.heic'}
                maxCount={100}
                dragable
                aiEdit
              />
            </div>
          </Skeleton>
        </div>

        <CustomModal
          title="操作记录"
          open={isRecord}
          modalCancel={onCancelrecord}
          footer={false}
        >
          <Record type={1} id={childId} />
        </CustomModal>
      </div>
    </Form.Provider>
  )
}

export default Goodsdetail

type MaterialDetailType =
  // 新增
  | 'Add'
  // 编辑
  | 'Edit'
  // 详情
  | 'Detail'
  // 禁用
  | 'Disable'
  // 启用
  | 'Undisable'
  // 复制
  | 'Copy'
// 物料信息-编辑
import { useEffect, useReducer } from 'react'
import { Button, message, Form, Skeleton, Space, Divider } from 'antd'
import Maininfo from '../../modules/goodsdetailmodules/maininfo'
import Uploadimg from '../../modules/goodsdetailmodules/uploadimg'
import AptitudeAttach from '../../modules/goodsdetailmodules/AptitudeAttach'
import Style from './goodsmanage.module.scss'
import { ADD_PRODUCTCHILD, GET_CODEPRODUCT_DETAIL } from '../../api/MaterialApi'
import { GET_CATEGORY_FRONTEND_HINT_TEXT } from '@/api/categoryQualificationApi'
import { history, useTypedSelector } from '../../redux/store'
import { useDispatch } from 'react-redux'
import { ProductChildParams } from '../../api/Params'
import {
  setformStateInitAction,
  setformStateAction,
} from '../../modules/ControlformState'
import { useLocation } from 'react-router-dom'
import { setModuleDataAction } from '../../modules/pagecache'
import CustomModal from '../../components/ModalUser'
import Record from './components/record'
import useHook from './hook'
import Originalpic from '../../modules/goodsdetailmodules/originalpic'
import { RoleType, isResponseCodeSuccess } from '../../tools/util'
import Mainpic from '../../modules/goodsdetailmodules/mainpic'
import Secondaryinfo from '../../modules/goodsdetailmodules/secondaryinfo'
import Expandattr from '../../modules/goodsdetailmodules/expandattr'
import MaterialType from '../../modules/goodsdetailmodules/materialType'
import AssociationItems from '../../modules/goodsdetailmodules/associationItems'
import { materialTypeEnum } from '../../global/enum/product'
import ExternalLink, {
  ExternalLinkType,
  toExternalLinkPayload,
} from '@/modules/goodsdetailmodules/externallink'

const ACTION_TYPE = {
  SET_CURRENT_PARAM: 'set_current_param', // 设置当前页面参数
  CHANGE_DATA: 'CHANGE_DATA', // 替换所有状态
  CHANGE_ISASSESSINGDATA: 'CHANGE_ISASSESSINGDATA',
  CHANGE_LOADING: 'CHANGE_LOADING',
  SET_DISPLAY_DEL_BTN_INDEX: 'SET_DISPLAY_DEL_BTN_INDEX', // 关联项目信息列表隐藏删除按钮
  CHANGE_CAN_ITEM_EDIT: 'CHANGE_CAN_ITEM_EDIT', // 关联项目信息是否可编辑
}
interface State {
  // 当前参数
  currentparam: nowpagesparam
  isAssessing: string
  isloading: boolean
  displayDelBtnIndex: number
  canItemEdit: boolean
}
interface nowpagesparam {
  tempId?: string // 暂存商品 id
  childId?: string // 子商品 id
  // 选中的tree层级
  selectTreeData?: treeType
  BtnState?: MaterialDetailType[] // 模块状态
}
export interface treeType {
  id: string // 树 id
  title: string // 树名称
  level: string // 树层级
  parentId?: string // 父级id
}
const defaultState: State = {
  currentparam: {},
  isAssessing: '0',
  isloading: false,
  displayDelBtnIndex: 0,
  canItemEdit: false,
}
const reducer = (state: State, action: { type: string; value?: any }) => {
  let arr = { ...state }
  switch (action.type) {
    case ACTION_TYPE.SET_CURRENT_PARAM:
      arr.currentparam = action.value
      return arr
    case ACTION_TYPE.CHANGE_DATA:
      arr = action.value
      return arr
    case ACTION_TYPE.CHANGE_ISASSESSINGDATA:
      arr.isAssessing = action.value
      return arr
    case ACTION_TYPE.CHANGE_LOADING:
      arr.isloading = action.value
      return arr
    case ACTION_TYPE.SET_DISPLAY_DEL_BTN_INDEX:
      arr.displayDelBtnIndex = action.value
      return arr
    case ACTION_TYPE.CHANGE_CAN_ITEM_EDIT:
      arr.canItemEdit = action.value
      return arr
    default:
      return { ...state }
  }
}

const setChangeLoading = (params: boolean) => ({
  type: ACTION_TYPE.CHANGE_LOADING,
  value: params,
})
const setAssessing = (params: string) => ({
  type: ACTION_TYPE.CHANGE_ISASSESSINGDATA,
  value: params,
})
// 重新加载数据
const reloadDataAction = (params: State) => ({
  type: ACTION_TYPE.CHANGE_DATA,
  value: params,
})

// 设置关联项目信息列表隐藏删除按钮
const setDisplayDelbtnIndex = (params: number) => ({
  type: ACTION_TYPE.SET_DISPLAY_DEL_BTN_INDEX,
  value: params,
})

// 关联项目信息是否可编辑
const changeCanItemEditAction = (params: boolean) => ({
  type: ACTION_TYPE.CHANGE_CAN_ITEM_EDIT,
  value: params,
})

// 路由参数
interface RouteParam extends nowpagesparam {
  init?: boolean // 是否初始化
  copydata?: any // copy
}

const Goodsdetail = () => {
  const {
    usehookstate,
    form,
    platform_form,
    setProjectQuotation,
    onChangePic,
    onChangeAptitude,
    onChangeDetailPic,
    onChangeCate,
    onChangeBrandSale,
    onClickClose,
    onCancelrecord,
    onChangeLoading,
    getformatFormFields,
    reloaddata,
    tempCode,
    setTempCodeFun,
    onChangeDelivery,
    setMaterialType,
    formatFormFields,
    changeItemList,
    onFieldsChange,
    clickCopy,
    externalLinkList,
    setExternalLinkList,
    setQualityDataList,
    checkProductForbidChar,
    checkTaxCodeBlacklist,
    setReportFieldConfigList,
    savedReportFieldValues,
    setDetailAuditType,
  } = useHook()
  const [pagesstate, dispatch] = useReducer(reducer, defaultState)
  const dispatchRedux = useDispatch()
  const {
    projectQuotation,
    pictures,
    qualDocFileList,
    requiredAttachTypes,
    frontendHintText,
    detailPic,
    productCode,
    fieldList,
    isRecord,
    loadingPage,
    hasDelivery,
    unitDisabled,
    materialType,
    itemsList,
    qualityDataList,
  } = usehookstate
  const { isAssessing, isloading, canItemEdit } = pagesstate
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { tempId, childId } = pagesstate.currentparam
  const { role } = useTypedSelector((state) => state.authtoken)
  const { pagekey } = useTypedSelector((state) => state.pageCache)
  const location = useLocation<RouteParam>()
  const { state, pathname } = location
  // 控制异步请求标识
  useEffect(() => {
    const flag = getpagecache()
    if (flag && !state) {
      // 读取缓存的公共模块状态
      reloaddata(flag.commonState)
      // 设置form数据
      form.setFieldsValue(flag.formState)
      // 读取缓存的当前模块状态
      dispatch(reloadDataAction(flag.pageState))
      dispatch(setAssessing(flag.formState.isAssessing))
      // 判断物料属性
      materialattrDisabled(flag.pageState.currentparam.BtnState)
    } else if (state) {
      dispatchRedux(setformStateInitAction())
      materialattrDisabled(state.BtnState)
      getProductInfo(state)
      // form.setFieldsValue({ childId: state.childId });//设置物料id 如果为新增则是空 用于maininfo页面判断
    }
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    // 缓存存数据
    const pathName = history.location.pathname + 'goodsInfo'
    const formstate = form.getFieldsValue()
    const action = setModuleDataAction({
      key: pathName,
      data: {
        commonState: usehookstate, // 公共状态
        pageState: pagesstate, // 当前状态
        formState: formstate,
      },
    })
    dispatchRedux(action)
    return () => {
      const formstate = form.getFieldsValue()
      const action = setModuleDataAction({
        key: pathName,
        data: {
          commonState: usehookstate, // 公共状态
          pageState: pagesstate, // 当前状态
          formState: formstate,
        },
      })
      dispatchRedux(action)
    }
    // eslint-disable-next-line
  }, [usehookstate, pagesstate])

  const handleLinkChange = (newList: ExternalLinkType[]) => {
    setExternalLinkList(newList)
  }

  // 获取数据
  const getpagecache = () => {
    const pathName = history.location.pathname + 'goodsInfo'
    const data = pagekey.filter((item) => item.key === pathName)
    if (data.length === 1) {
      return data[0].data
    }
    return null
  }

  // 编辑获取数据
  const getProductInfo = async (state: any) => {
    onChangeLoading(true)
    const res = await GET_CODEPRODUCT_DETAIL({
      code: state.tempCode,
    })
    if (isResponseCodeSuccess(res.code)) {
      const resData = res.data
      // 资质场景：依据详情返参 auditType（ADD/MODIFY）推算
      setDetailAuditType(resData.auditType)
      // 初始进入详情：通过类目 ID 调接口获取当前四级类目的前台提示文案
      const hintRes = await GET_CATEGORY_FRONTEND_HINT_TEXT({
        categoryId: resData.cateMdmId,
      })
      const frontendHintText = isResponseCodeSuccess(hintRes.code)
        ? hintRes.data
        : ''
      await onChangeCate(
        resData.cateMdmId,
        undefined,
        resData.code,
        frontendHintText,
      )
      dispatch(setAssessing(resData.isAssessing))
      // 编辑我的物料时，若物料的关联项目为空，此时可以对项目信息进行修改和新增
      resData.projectValueInfoList.length === 0 &&
        dispatch(changeCanItemEditAction(true))
      const formatData = formatFormFields(resData)
      dispatch(setDisplayDelbtnIndex(resData.projectValueInfoList.length))
      form.setFieldsValue(formatData)
      setTempCodeFun(resData.code)
      setProjectQuotation(resData.projectQuotation)
      const newExternalLinks = resData.externalLinks.map((item: any) => {
        return {
          ...item,
          externalFile: item.externalFile ? JSON.parse(item.externalFile) : [],
        }
      })
      setExternalLinkList(newExternalLinks)
    }
    onChangeLoading(false)
  }

  // 物料属性是否可修改
  const materialattrDisabled = (params?: MaterialDetailType[]) => {
    let flag = false
    if (role === RoleType.SOURCE_PURCHASE_MAN && params) {
      // 采购员 物料属性
      flag = params.indexOf('Add') !== -1 ? false : true
    }
    dispatchRedux(setformStateAction([{ key: 'materialattr', disabled: flag }]))
  }

  // 提交新增物料 暂存物料提交 数据
  async function onSubmmit() {
    try {
      // 格式化表单数据
      const values = await getformatFormFields()
      const canPassForbidCharCheck = await checkProductForbidChar(values)
      if (!canPassForbidCharCheck) {
        return
      }
      // 提交前校验税编是否命中当前货主的黑名单。货主由 MPM 按物料类型推导，
      // 这里只把 productType 传过去，不在前端算货主，避免两端口径走偏
      const canPassBlacklistCheck = await checkTaxCodeBlacklist(
        values.productType,
        values.taxCategoryCode,
      )
      if (!canPassBlacklistCheck) {
        return
      }
      if (qualityDataList.length > 10) {
        message.warning('资质图片最多上传10张')
        return
      }
      if (
        !itemsList.length &&
        materialTypeEnum.getLabelByValue(values.productType) ===
          '电商供应商物料'
      ) {
        message.error('电商供应商物料至少添加一个关联项目')
        return
      }
      const params: any = {
        ...values,
        saveType: '2', // 必须 操作类型；1、提交 2、暂存
        fourthCateMdmId: values.fourthCateMdmId || values.cateMdmId, // 类目ID
        externalLinks: toExternalLinkPayload(externalLinkList),
      }
      // editgoods 路由下不传 reportFieldValues
      if (pathname.includes('editgoods')) {
        delete params.reportFieldValues
      }
      if ((!childId && !tempId) || (tempId && !childId)) {
        // 校验品牌型号问题
        commit(params)
      } else {
        // 直接提交
        commit(params)
      }
    } catch (errorInfo) {
      const error = (errorInfo as any).errorFields[0].errors[0]
      message.warning(error)
      const errorname = (errorInfo as any).errorFields[0].name
      // 返回报错信息，滚动到第一个报错的位置
      form.scrollToField(errorname.toString(), { behavior: 'smooth' })
    }
  }

  // 提交数据 立即提交 暂存
  async function commit(params: ProductChildParams) {
    dispatch(setChangeLoading(true))
    const msg = '提交中'
    message.loading(msg, 0)
    const resData = await ADD_PRODUCTCHILD(params)
    dispatch(setChangeLoading(false))
    if (resData.code === 0) {
      if (childId) {
        message.success('已提交')
      } else {
        message.success('已成功')
      }
      onClickClose(history.location.pathname + 'goodsInfo')
    } else {
      message.destroy()
    }
  }

  // 按钮类型
  const ButtonComponents = () => {
    let EditBtn = null
    const EditChild = null
    const DisableBtn = null
    const UndisableBtn = null
    const CopyBtn = null
    EditBtn =
      isAssessing !== '0' ? null : (
        <Button
          type="link"
          size="small"
          loading={isloading}
          onClick={() => onSubmmit()}
        >
          提交
        </Button>
      )
    return (
      <div className={Style.btnbox}>
        <div className={Style['btn-left-box']}></div>
        <div className={Style['btn-center-box']}></div>
        <div className={Style['btn-right-box']}>
          <Space>
            <Button type="link" size="small" onClick={clickCopy}>
              复制
            </Button>
            {EditBtn}
            {EditChild}
            {DisableBtn}
            {UndisableBtn}
            {CopyBtn}
            <Button type="link" size="small" onClick={onClickClose}>
              关闭
            </Button>
          </Space>
        </div>
      </div>
    )
  }

  const diaableMaterialType = () => {
    // 物料编辑页面禁止修改物料类型
    if (pathname.includes('editgoods')) {
      return true
    }

    return false
  }

  return (
    <Form.Provider>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <span style={{ paddingLeft: '20px' }}>
          项目报价员：{projectQuotation || '—'}
        </span>
        <ButtonComponents />
      </div>
      <div className={Style.container}>
        <div className={Style.box}>
          <Skeleton loading={loadingPage} active>
            <MaterialType
              form={form}
              setMaterialType={setMaterialType}
              type="single"
              diaableMaterialType={diaableMaterialType()}
              onFieldsChange={onFieldsChange}
            />
          </Skeleton>
        </div>
        <div className={Style.box}>
          <div className={Style.boxtitle}>
            <span>主要信息</span>
          </div>
          <Divider style={{ margin: '0' }} />
          <Skeleton loading={loadingPage} active>
            <Maininfo
              form={form}
              categoryReadOnly={pathname.includes('editgoods')}
              onChangeCate={onChangeCate}
              onChangeSale={onChangeBrandSale}
              tempCode={tempCode}
              unitDisabled={unitDisabled}
              materialType={materialType}
              onFieldsChange={onFieldsChange}
            />
          </Skeleton>
        </div>
        <div className={Style.box}>
          <div className={Style.boxtitle}>
            <span>次要信息</span>
          </div>
          <Divider style={{ margin: '0' }} />
          <Skeleton loading={loadingPage} active>
            <Secondaryinfo
              form={form}
              onChangeDelivery={onChangeDelivery}
              hasDelivery={hasDelivery}
              onFieldsChange={onFieldsChange}
            />
          </Skeleton>
        </div>
        {(materialType === '1' || materialType === '2') && (
          <div className={Style.box}>
            <div className={Style.boxtitle}>
              <span>关联项目信息</span>
              {materialTypeEnum.getLabelByValue(
                form.getFieldValue('productType'),
              ) === '电商供应商物料' && (
                <span style={{ color: '#ff4d4f', marginLeft: 10 }}>
                  * 请至少添加一个关联项目
                </span>
              )}
            </div>
            <Divider style={{ margin: '0' }} />
            <Skeleton loading={loadingPage} active>
              <AssociationItems
                form={platform_form}
                normalForm={form}
                onFieldsChange={onFieldsChange}
                itemsList={itemsList}
                changeItemList={changeItemList}
                readOnly={!canItemEdit}
                // 5.9.2需求由于mpm未处理完 暂时隐藏不跟随5.9.2版本上线
                // isEditView
                // displayDelBtnIndex={displayDelBtnIndex}
                qualityDataList={qualityDataList}
                setQualityDataListAction={setQualityDataList}
                isDetailPage={true}
              />
            </Skeleton>
          </div>
        )}

        <div className={Style.box}>
          <div className={Style.boxtitle}>
            <span>拓展属性</span>
            <span className={Style.tips}>
              拓展属性标题为<span className={Style.blueTip}>蓝色</span>
              代表有平台项目对该拓展属性有要求，鼠标移到拓展属性标题即可查看具体平台项目。
              <span
                style={{
                  color: '#8C8C8C',
                  fontSize: '12px',
                  lineHeight: '24px',
                }}
              >
                都需填写，无法填写的填/【如果是大批量无法填写，可能是四级类目选错】
              </span>
            </span>
          </div>
          <Divider style={{ margin: '0' }} />
          <Skeleton loading={loadingPage} active>
            <Expandattr
              form={form}
              fieldList={fieldList}
              itemsList={itemsList}
              frontendHintText={frontendHintText}
              onFieldsChange={onFieldsChange}
            />
          </Skeleton>
        </div>
        <div className={Style.box}>
          <Divider style={{ margin: '0' }} />
          <AptitudeAttach
            dataSource={qualDocFileList}
            onChange={onChangeAptitude}
            productCode={productCode}
            loading={loadingPage}
            requiredAttachTypes={requiredAttachTypes}
          />
        </div>
        <div className={Style.box}>
          <div className={Style.boxtitle}>
            <span>外部链接/价格佐证</span>
          </div>
          <Divider style={{ margin: '0' }} />
          <Skeleton loading={loadingPage} active>
            <ExternalLink
              form={form}
              externalLinkList={externalLinkList}
              onLinkChange={handleLinkChange}
            />
          </Skeleton>
        </div>
        <div className={Style.box}>
          <div className={Style.boxtitle}>
            <span>图文信息</span>
          </div>
          <Divider style={{ margin: '0' }} />
          <Skeleton loading={loadingPage} active>
            <div className={Style.picinfobox}>
              {/* <div className={Style.picinfotitle}>
                <span className={Style.text}>图片关系</span>
              </div> */}
              {/* true 显示 匹配、类似 注意必填校验 */}
              <Mainpic required form={form} onFieldsChange={onFieldsChange} />
              <div className={Style.picinfotitle}>
                <span className={Style.text}>
                  主图：
                  <span
                    style={{
                      color: '#8C8C8C',
                      fontSize: '12px',
                      lineHeight: '24px',
                    }}
                  >
                    尺寸：800×800 px。建议上传3张及以上，最多20张。第一张白底，其它尽量白底。主图要求颜色唯一，需要与描述或者拓展属性值一致【最低标准∶不低于在其他平台上架的标准】
                  </span>
                </span>
              </div>
              <Uploadimg
                dataSource={pictures}
                onChange={onChangePic}
                tempCode={tempCode}
                maxCount={20}
                fileType={'.bmp,.gif,.jpg,.png,.webp,.heic'}
                dragable
                aiEdit
              />
              {/* true 显示 可用、不可用 注意必填校验 */}
              <div hidden>
                <Originalpic
                  required={false}
                  form={form}
                  onFieldsChange={onFieldsChange}
                />
              </div>
              <div className={Style.picinfotitle}>
                <span className={Style.text}>
                  详情图：
                  <span
                    style={{
                      color: '#8C8C8C',
                      fontSize: '12px',
                      lineHeight: '24px',
                    }}
                  >
                    上传图片宽度不小于500 px，高度不限，最多100张。要图文丰富，需包含产品图、细节图、参数图、使用场景图，【最低标准:不低于在其他平台上架的标准】。一定不能包含:7天无理由退换货、送货上门、免费开票、水印、其它店铺信息、质保、包邮、链接、二维码、电话号码......等敏感词汇
                  </span>
                </span>
              </div>
              <Uploadimg
                dataSource={detailPic}
                onChange={onChangeDetailPic}
                tempCode={tempCode}
                isDetailPic
                fileType={'.bmp,.gif,.jpg,.png,.webp,.heic'}
                maxCount={100}
                dragable
                aiEdit
              />
            </div>
          </Skeleton>
        </div>

        <CustomModal
          title="操作记录"
          open={isRecord}
          modalCancel={onCancelrecord}
          footer={false}
        >
          <Record type={1} id={childId} />
        </CustomModal>
      </div>
    </Form.Provider>
  )
}

export default Goodsdetail

type MaterialDetailType =
  // 新增
  | 'Add'
  // 编辑
  | 'Edit'
  // 详情
  | 'Detail'
  // 禁用
  | 'Disable'
  // 启用
  | 'Undisable'
  // 复制
  | 'Copy'
